import { useLazyOmniChatSessionHistories } from 'hooks';
import React, { createContext, useEffect } from 'react';
import { ChatSessionDto, FindAllChatSessionsHistoryDto } from 'types';
import { useContext } from 'react';
import dayjs from 'dayjs';

export type OmniHistoriesManageContextProps = {
  chatSession?: ChatSessionDto;
  setChatSession: (chatSession: ChatSessionDto | undefined) => void;

  searchChatSessions: (value?: Partial<FindAllChatSessionsHistoryDto>) => void;
  groupedData?: {
    date: string;
    sessions: ChatSessionDto[];
  }[];
  loadingSearchChatSession?: boolean;
  countChatSessions?: number;
  hasMoreChatSessions: boolean;
  loadMoreChatSessions: () => void;
  originalArgs: FindAllChatSessionsHistoryDto | undefined;
};

export const OmniHistoriesManageProviderContext = createContext<OmniHistoriesManageContextProps | undefined>(undefined);

export const OmniHistoriesManageProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [chatSession, setChatSession] = React.useState<ChatSessionDto | undefined>(undefined);
  const { originalArgs, count, groupedData, isLoading, hasMore, fetchData, handleLoadMore, isFetching } =
    useLazyOmniChatSessionHistories();

  useEffect(() => {
    fetchData({
      fromStartTime: dayjs().toISOString(),
      toStartTime: dayjs().endOf('day').toISOString(),
      source: null
    });
  }, []);

  return (
    <OmniHistoriesManageProviderContext.Provider
      value={{
        chatSession: chatSession,
        setChatSession: setChatSession,

        searchChatSessions: fetchData,
        groupedData: groupedData,
        loadingSearchChatSession: isLoading || isFetching,
        countChatSessions: count,
        hasMoreChatSessions: hasMore,
        loadMoreChatSessions: handleLoadMore,
        originalArgs: originalArgs
      }}
    >
      {/* <Spin className='max-h-full overflow-hidden' spinning={isLoading || isFetching}> */}
      {children}
      {/* </Spin> */}
    </OmniHistoriesManageProviderContext.Provider>
  );
};
export default OmniHistoriesManageProvider;

export const useOmniHistoriesManageContext = (): OmniHistoriesManageContextProps => {
  const context = useContext(OmniHistoriesManageProviderContext);
  if (!context) {
    throw new Error('useOmniHistoriesManageContext must be used within a OmniHistoriesProvider');
  }
  return context;
};
